import { render, staticRenderFns } from "./garageVendorInvite.vue?vue&type=template&id=66ad56e8"
import script from "./garageVendorInvite.vue?vue&type=script&lang=js"
export * from "./garageVendorInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports